import React, { useState, useEffect, useCallback } from "react";
import { me } from "../../services/accountApi";
import LoginPage from "./LoginPage";
import SetPasswordPage from "./SetPasswordPage";
import { ErrorState } from "../common/ui";

const PREFIX = "#/set-password?token=";
const readToken = () => {
  const h = window.location.hash || "";
  if (!h.startsWith(PREFIX)) return null;
  return new URLSearchParams(h.slice(h.indexOf("?") + 1)).get("token") || "";
};

const centered = { position: "fixed", inset: 0, background: "var(--bg)", color: "var(--text)", display: "flex", flexDirection: "column", gap: 12, alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 16, textAlign: "center" };

export default function AuthGate({ children, onSignedIn }) {
  const [state, setState] = useState("checking");
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(readToken);

  const check = useCallback(() => {
    setState("checking");
    me()
      .then((d) => { setUser(d.user); setState("in"); })
      .catch((err) => setState(err && err.response && err.response.status === 401 ? "out" : "error"));
  }, []);

  useEffect(() => { check(); }, [check]);
  useEffect(() => {
    const h = () => setToken(readToken());
    window.addEventListener("hashchange", h);
    return () => window.removeEventListener("hashchange", h);
  }, []);

  const signedIn = (u) => {
    setUser(u); setToken(null); setState("in");
    if (onSignedIn) onSignedIn(u);
  };

  if (token !== null) {
    return <SetPasswordPage token={token} onSignedIn={signedIn} onBack={() => { setToken(null); if (state !== "in") setState("out"); }} />;
  }

  if (state === "checking") {
    return <div style={centered}><div className="spinner" /></div>;
  }

  if (state === "error") {
    return (
      <div style={centered}>
        <div style={{ width: "min(380px, 100%)" }}>
          <ErrorState message="Cannot reach the server." onRetry={check} />
        </div>
      </div>
    );
  }

  if (state === "out") return <LoginPage onSignedIn={signedIn} />;

  return typeof children === "function" ? children(user) : children;
}
